import "layouts/Home/Home.css";
import React from "react";
import {request} from "../../../api-client";
import localization from "../../../config/localization";
import './favorites.css';
import FavoritesCarousel from "./FavoritesCarousel";
import {setPageTitle} from "../../../api-client/core/authentication/utils";
import {pushIfDoesNotExist} from "../../../utils";
import HomeSearchInput from "../../../components/Letflow/HomeSearchInput";
import { Star } from "@material-ui/icons";
import BloomSpinner from "../../../assets/img/bloom_spinner_grey.gif";

class FavoritesContentCreator extends React.Component {

  state = {
    contentCreators: [],
    pageReady: false
  };

  componentDidMount = () => {
    setPageTitle(localization.get('title.favorites'))
    document.getElementsByTagName('html')[0].scrollTop = 0
    request.user.favorites()
      .then((user) => {
        let creators = user.contentCreatorsFavorites
        let types = [];
        creators.forEach(c => pushIfDoesNotExist(types, c.type));
        this.setState({
          contentCreators: user.contentCreatorsFavorites,
          unfilteredContentCreators: user.contentCreatorsFavorites,
          contentCreatorTypes: types
        }, () => this.setState({pageReady: true}))
      })
  }


  render() {      
    const {contentCreators, contentCreatorTypes} = this.state;
    
    return (
      <div className="favorites-category-container">
        <HomeSearchInput
          value={this.state.search}
          placeholder="favorites.search_creators"
          onSearch={value => {
            this.setState({pageReady: false}, () => {
              let creators = this.state.unfilteredContentCreators.filter(i =>
                i.name.toLowerCase().includes(value.toLowerCase()) ||
                (i.synonyms && i.synonyms.toLowerCase().includes(value.toLowerCase()))
              );
              let types = []
              creators.forEach(c => pushIfDoesNotExist(types, c.type));
              console.log(creators);
              console.log(types);
              this.setState({
                search: value,
                contentCreators: creators,
                contentCreatorTypes: types,
                pageReady: true
              });
            })
          }
          }
        />
        <div class="favorites-section-title">
          <div style={{textTransform: 'uppercase', display: 'flex', alignItems: 'center', fontSize: 18, fontWeight: 'bold', lineHeight: '36px', marginBottom: '20px'}}><Star style={{marginRight: 5, fontSize: 18}}/>{localization.get("my_favorites")}</div>
        </div>
        {
          !this.state.pageReady
          ?
            <div style={{ height: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}>
              <img style={{width: 100, height: 100, marginTop: "calc(43vh - 120px)"}} src={BloomSpinner} alt="Loading logo"/>
            </div>
          :
            <div className="favorite-creators-container">
              {contentCreatorTypes.map((contentCreatorType, key) =>
                <React.Fragment key={key}>
                  <h3>{contentCreatorType.name}</h3>
                  <FavoritesCarousel {...this.props} elements={contentCreators.filter(contentCreator => contentCreator.type.id === contentCreatorType.id)} type={'content_creator'}/>
                </React.Fragment>
              )}

              {(contentCreators.length === 0) &&
                <div
                  style={{
                    float: "left",
                    position: "relative",
                    width: "100%",
                    textAlign: "center",
                    marginTop: "30px",
                    fontSize: "20px",
                    padding: "40px"
                  }}>{localization.get("favorites.no_result")}</div>
              }
            </div>
        }
      </div>
    )
  }
}

export default FavoritesContentCreator;
